import type { UseQueryResult } from "@tanstack/react-query";
import { clsx } from "clsx";
import { InputCity } from "../input-city";
import { SwapButton } from "../swap-button";
import { FieldError } from "@jetblue/kit/field-error";
import type { Airport } from "@jb-dotcom/api/odb/transformed";

type InputRouteLabels = {
  destination: string;
  errors: {
    destination: string;
    origin: string;
  };
  origin: string;
  close: string;
  swap: string;
};

export type InputRouteProperties = {
  className?: string;
  destination: string | undefined;
  destinationIsRequired?: boolean | undefined;
  destinationName?: string | undefined;
  labels: InputRouteLabels;
  odRouteData: {
    destination: NonNullable<UseQueryResult<Airport[]>>["data"];
    origin: NonNullable<UseQueryResult<Airport[]>>["data"];
  };
  onDestinationChange: (destination: string) => void;
  onOriginChange: (origin: string) => void;
  onSwapClick: () => void;
  origin: string | undefined;
  originIsRequired?: boolean | undefined;
  originName?: string | undefined;
  showValidation?: boolean | undefined;
};
export const InputRoute = ({
  className,
  destination,
  destinationIsRequired,
  destinationName,
  labels,
  odRouteData,
  onDestinationChange,
  onOriginChange,
  onSwapClick,
  origin,
  showValidation,
  originIsRequired,
  originName,
}: InputRouteProperties) => (
  <div className={clsx("flex flex-row", className)}>
    <InputCity
      className="order-1 flex-1"
      error={
        <FieldError>
          {({ isInvalid }) => (isInvalid ? labels.errors.origin : null)}
        </FieldError>
      }
      isRequired={originIsRequired}
      items={odRouteData.origin}
      labels={{ close: labels.close, input: labels.origin }}
      name={originName}
      selectedKey={origin}
      setSelectedKey={onOriginChange}
      showValidation={showValidation}
    />

    <InputCity
      className="order-3 flex-1"
      error={
        <FieldError>
          {({ isInvalid }: { isInvalid: boolean }) =>
            isInvalid ? labels.errors.origin : null
          }
        </FieldError>
      }
      isRequired={destinationIsRequired}
      items={odRouteData.destination}
      labels={{ close: labels.close, input: labels.destination }}
      name={destinationName}
      selectedKey={destination}
      setSelectedKey={onDestinationChange}
      showValidation={showValidation}
    />
    <SwapButton label={labels.swap} onClick={onSwapClick} />
  </div>
);
